/**
 * Footer: menu accordions on phones, the cookie-settings link handoff, and the
 * language / currency dropdowns (shared with the header toolbar markup).
 * Was two inline <script> blocks in sections/footer-v2.liquid; moved here so
 * the ~6.5KB is cached across pages instead of shipped in every HTML response.
 * Deferred: the whole DOM is parsed before it runs, as it was when inline.
 */
  (function () {
    var BREAKPOINT = 768;
    var bound = false;

    function menuColumns() {
      return document.querySelectorAll('.footer__col--menu');
    }

    function setState(col, open) {
      var trigger = col.querySelector('.footer__accordion-trigger');
      var list = col.querySelector('.footer__menu-list');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (list) {
        list.setAttribute('aria-hidden', open ? 'false' : 'true');
        // inert keeps Tab out of a collapsed list; aria-hidden alone does not.
        list.inert = !open;
      }
    }

    /*
      One delegated listener rather than one per column, so crossing the
      breakpoint can never bind a second copy — which used to leave the
      accordion unable to open, each click toggling it twice.
    */
    function bindAccordion() {
      if (bound) return;
      bound = true;

      document.addEventListener('click', function (e) {
        if (window.innerWidth > BREAKPOINT) return;

        var trigger = e.target.closest('.footer__accordion-trigger');
        if (!trigger) return;

        var col = trigger.closest('.footer__col--menu');
        if (!col) return;

        var wasOpen = col.classList.contains('is-open');

        menuColumns().forEach(function (c) {
          c.classList.remove('is-open');
          setState(c, false);
        });

        if (!wasOpen) {
          col.classList.add('is-open');
          setState(col, true);
        }
      });
    }

    /*
      Desktop shows every list in full, so nothing there may be marked hidden
      from assistive tech. On mobile the state follows the is-open class.
    */
    function sync() {
      var narrow = window.innerWidth <= BREAKPOINT;

      menuColumns().forEach(function (col) {
        setState(col, narrow ? col.classList.contains('is-open') : true);
        setTriggerRole(col, narrow);
      });
    }

    /*
      The heading only does something on phones. On desktop it was still a
      button with a hand cursor that clicked into nothing, and screen readers
      announced a button (14zcqntmb5j). There it is a plain heading instead.
    */
    function setTriggerRole(col, narrow) {
      var trigger = col.querySelector('.footer__accordion-trigger');
      if (!trigger) return;

      if (narrow) {
        trigger.removeAttribute('role');
        trigger.removeAttribute('aria-level');
        trigger.removeAttribute('tabindex');
      } else {
        trigger.setAttribute('role', 'heading');
        trigger.setAttribute('aria-level', '2');
        trigger.setAttribute('tabindex', '-1');
        trigger.removeAttribute('aria-expanded');
      }
    }

    function init() {
      bindAccordion();
      sync();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    var wasNarrow = window.innerWidth <= BREAKPOINT;
    window.addEventListener('resize', function () {
      var isNarrow = window.innerWidth <= BREAKPOINT;
      if (isNarrow !== wasNarrow) {
        wasNarrow = isNarrow;
        sync();
      }
    });

    // Legal links: open the Consentmo accessibility widget (same behavior as the
    // "Display Accessibility Widget" link handled in altenew.js)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accessibility-widget-trigger]');
      if (!trigger) return;
      e.preventDefault();
      if (window.openAccessibilityWidget) {
        window.openAccessibilityWidget();
        return;
      }
      var accessibility = window.Consentmo && window.Consentmo.accessibility;
      if (accessibility && typeof accessibility.open === 'function') accessibility.open();
    });

    /*
      Legal links: the cookie preferences link.

      The theme renders the link so it can be styled and ordered like its
      neighbours, but the thing that actually opens the dialog is the consent
      app's own link, which the app inserts next to ours and CSS hides. So ours
      ships inert and is only revealed once that link exists — the app deciding
      to insert it is the one reliable sign that there is a dialog to open.
      `Consentmo.openDialog` is no help here: it is defined even where the dialog
      does nothing, such as a region with no consent banner or the theme editor's
      preview, and a link that opens nothing is worse than no link at all.
    */
    var COOKIE_TRIGGER = '[data-cookie-preferences-trigger]';
    var APP_COOKIE_LINK = '.csm-cookie-widget-link';

    function activateCookieLink() {
      if (!document.querySelector(APP_COOKIE_LINK)) return false;

      document.querySelectorAll(COOKIE_TRIGGER).forEach(function (trigger) {
        trigger.classList.remove('is-inert');
        trigger.removeAttribute('aria-hidden');
        trigger.removeAttribute('tabindex');
      });

      return true;
    }

    function watchForCookieLink() {
      var legal = document.querySelector('.footer__legal-links');
      if (!legal || activateCookieLink()) return;

      /*
        The app inserts its link well after DOMContentLoaded, straight into this
        nav. Watching the nav rather than polling means the link appears the
        moment the app is ready; the observer stops itself once it has fired.
      */
      var observer = new MutationObserver(function () {
        if (activateCookieLink()) observer.disconnect();
      });

      observer.observe(legal, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchForCookieLink);
    } else {
      watchForCookieLink();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(COOKIE_TRIGGER);
      if (!trigger) return;

      e.preventDefault();

      var appLink = document.querySelector(APP_COOKIE_LINK);
      if (appLink) appLink.click();
    });
  })();

  /* The footer renders only the current country; the full list (~190 items) is
     fetched from sections/localization-countries.liquid on first open. */
  function loadLazyList(list) {
    if (!list || list.dataset.lazyList !== 'countries' || list.dataset.loaded) return;
    list.dataset.loaded = 'loading';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?section_id=localization-countries', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-lazy-source="countries"]');
        if (!src) throw new Error('no list');
        if (list.dataset.flags === 'false') src.querySelectorAll('.currency-flag').forEach(function (f) { f.remove(); });
        list.innerHTML = src.innerHTML;
        list.dataset.loaded = 'true';
      })
      .catch(function () { delete list.dataset.loaded; });
  }

  /* Language / currency dropdowns. Shared with the header toolbar markup. */
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-disclosure-toggle]');
    if (!toggle) return;

    const disclosure = toggle.closest('.disclosure');
    const list = disclosure.querySelector('[data-disclosure-list]');

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';

    // close all
    document.querySelectorAll('.disclosure').forEach((d) => {
      d.querySelector('[data-disclosure-toggle]')?.setAttribute('aria-expanded', 'false');
      d.querySelector('[data-disclosure-list]')?.classList.remove('is-open');
    });

    if (!isOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      list.classList.add('is-open');
      loadLazyList(list);
    }
  });

  document.addEventListener('click', function (e) {
    const option = e.target.closest('[data-disclosure-option]');
    if (!option) return;

    e.preventDefault();

    const disclosure = option.closest('.disclosure');
    const input = disclosure.querySelector('[data-disclosure-input]');
    const form = disclosure.closest('form');

    input.value = option.dataset.value;
    form.submit();
  });
